import { ExchangeSpin, ChevronUp, Close } from "@/components/Icon"
import React from "react"
import { useTranslation } from "react-i18next"
import Typography from "@/components/Typography"
import Flex from "@/components/Flex"
import Container from "@/components/Container"
import Button from "@/components/Button"
import Box from "@/components/Box"
import Row from "@/components/Row"
import Column from "@/components/Column"
import { JobMapByLocation, JobMapByTeam } from "../utils/useLever"
import FilterMenuItem from "./FilterMenuItem"
import { CheckboxMenu } from "./CheckboxMenu"
import { useFreeze } from "@/utils/useFreeze"

type PopOutMenuProps = {
  onCloseButtonClick: () => void
  jobMapByTeam: JobMapByTeam
  jobMapByLocation: JobMapByLocation
  teamsFilter: string[]
  setTeamsFilter: (teams: string[]) => void
  locFilter: string[]
  setLocFilter: (loc: string[]) => void
}

export const PopOutMenu = ({
  onCloseButtonClick,
  jobMapByTeam,
  jobMapByLocation,
  teamsFilter,
  setTeamsFilter,
  locFilter,
  setLocFilter,
}: PopOutMenuProps) => {
  const { t } = useTranslation("careers")
  const handleReset = () => {
    setTeamsFilter(["All Teams"])
    setLocFilter(["All Location"])
  }
  useFreeze()

  return (
    <React.Fragment>
      <Box
        width="100%"
        height="calc(100vh - 67px)"
        bg="backgroundLight"
        overflowY="scroll"
        customCss={{ WebkitOverflowScrolling: "touch" }}
      >
        <Container bg="backgroundLight" width="100%">
          <Flex
            alignItems="center"
            justifyContent="space-between"
            mt={"50px"}
            mb={5}
          >
            <Button
              variant="plain"
              display="flex"
              onClick={() => handleReset()}
            >
              <Typography variant="textCta" mt={"3px"} mr={1} color={"#D9475A"}>
                {t("filter.reset")}
              </Typography>
              <ExchangeSpin pb="5px" fontSize="24px" />
            </Button>
            <Button variant="plain">
              <Close
                fontSize="20px"
                color="secondaryDarkNavy"
                onClick={onCloseButtonClick}
              />
            </Button>
          </Flex>
        </Container>
        <Container>
          <Row>
            <Column width={1}>
              {" "}
              <FilterMenuItem
                title={t("join.teams")}
                content={
                  <CheckboxMenu
                    data={jobMapByTeam}
                    filterArray={teamsFilter}
                    setFilter={setTeamsFilter}
                    allField={"All Teams"}
                  />
                }
                mb={[2, 1]}
              />
              <FilterMenuItem
                title={t("join.location")}
                content={
                  <CheckboxMenu
                    data={jobMapByLocation}
                    filterArray={locFilter}
                    setFilter={setLocFilter}
                    allField={"All Location"}
                  />
                }
                mb={[2, 1]}
              />
            </Column>
          </Row>
        </Container>
      </Box>
      <Box
        bg="primaryBrightBlueLightBg"
        width="100%"
        height={"67px"}
        position="fixed"
        bottom={0}
      >
        <Button
          mx={"auto"}
          variant="plain"
          onClick={onCloseButtonClick}
          color="white"
          display={"flex"}
          alignItems="center"
          height="100%"
        >
          <ChevronUp fontSize="15px" mr={2} />
          <Typography variant="subtitle" mr={2}>
            {t("filter.close_filter_btn")}
          </Typography>{" "}
          <ChevronUp fontSize="15px" />
        </Button>
      </Box>
    </React.Fragment>
  )
}
